import { PropsWithChildren } from 'react';

import Config from '@config';
import {
  NotificationsSignalRProvider,
  SignalRAuthAdapter,
  useNotificationsSignalRContext,
} from '@gasbi/shared';

import http from '@/utils/http';

// Cookie (BFF) session: the hub is same-origin, the HttpOnly cookie rides on
// the WebSocket handshake by itself - no access token at all. "Silent sign-in"
// becomes a session probe: a 401 from /user means the session is gone and the
// shared provider should send the browser to the login flow.
const useAuthAdapter = (): SignalRAuthAdapter => ({
  signinSilent: async () => {
    const response = await http.get('/user', { validateStatus: () => true });
    if (response.status === 401) {
      throw { error: 'login_required' };
    }
  },
  signoutRedirect: async () => {
    const returnUrl = window.location.pathname + window.location.search;
    window.location.assign(`/api/login?returnUrl=${encodeURIComponent(returnUrl)}`);
  },
});

export const SignalRProvider = ({ children }: PropsWithChildren) => (
  <NotificationsSignalRProvider
    hubUrl={Config.VITE_WS_API_URL}
    useAuthAdapter={useAuthAdapter}
  >
    {children}
  </NotificationsSignalRProvider>
);

export const useSignalRContext = useNotificationsSignalRContext;
